export const translations = {
  id: {
    nav: {
      home: "Beranda",
      projects: "Proyek",
      about: "Tentang",
      contact: "Kontak",
      hire: "Rekrut Saya"
    },
    home: {
      hero: {
        explore: "Jelajahi Karya Saya",
        contact: "Hubungi Saya"
      },
      portfolio: {
        tag: "Portofolio",
        title1: "Proyek",
        title2: "Terbaru",
        more: "Lihat Proyek Lainnya"
      },
      experience: {
        tag: "Perjalanan",
        title1: "PENDIDIKAN & ",
        title2: "PENGALAMAN",
        eduPath: "JALUR PENDIDIKAN",
        expPath: "JALUR KARIR",
        academic: "Karier Akademik",
        professional: "Pengalaman Profesional",
        role1_desc: "Sebagai Pemrogram Pengembang Flutter Mobile",
        role2_desc: "Sebagai dukungan IT dan Implementor Aplikasi/Sistem Website Monitor Olahraga",
        role3_desc: "Magang sebagai Layanan Publikasi dan Pemrogram",
        role4_desc: "Sebagai Kreator Konten di saluran youtube Sadit Aditya"
      },
      education: {
        edu1_degree: "Kelulusan (Ilmu Pembelajaran dan Manajemen)",
        edu2_degree: "Pengembangan Web Frontend (FGA)",
        edu2_desc: "Mempelajari Pengembangan Web React JS.",
        edu3_degree: "Sekolah Menengah Atas",
        edu3_desc: "Jurusan IPA"
      },
      services: {
        title: "Apa yang Saya Lakukan",
        desc: "Saat ini saya bekerja dalam berbagai peran, sebagai Pengembang Web saya mendesain dan membuat berbagai situs web. Dan sebagai Desainer UI/UX saya membuat banyak desain untuk Aplikasi Web dan Seluler.",
        service1_title: "Kerja Keras",
        service1_desc: "Selalu percaya pada kerja keras dengan restu Tuhan yang akan membuat profesi saya hebat",
        service2_title: "Desain UI/UX",
        service2_desc: "Mendesain antarmuka yang modern dan ramah pengguna",
        service3_title: "Pengembangan Web",
        service3_desc: "Membangun situs web yang responsif dan berkinerja tinggi",
        service4_title: "Optimasi SEO",
        service4_desc: "Meningkatkan visibilitas situs web Anda di mesin pencari"
      },
      about: {
        greeting: "Halo! Nama Saya Surya Aditya",
        aka: "juga dikenal sebagai Sadit Aditya",
        desc1: "Saya seorang ",
        desc1_1: "Pengembang Frontend",
        desc1_2: " & ",
        desc1_3: "Desainer Web",
        desc1_4: " dari Pekanbaru, Riau, Indonesia. Saya senang membangun segalanya mulai dari situs web bisnis kecil hingga aplikasi web interaktif yang kaya.",
        desc2: "Jika Anda sebuah bisnis yang mencari kehadiran web atau pencari kerja yang ingin merekrut, Anda dapat menghubungi saya ",
        desc2_link: "di sini.",
        desc3: "Saya merancang dan membangun produk digital dengan kode yang sederhana dan indah. Saya berspesialisasi dalam pengembangan tema web kustom dan benar-benar mencintai apa yang saya lakukan.",
        btn_cv: "Lihat CV Saya",
        btn_hire: "Rekrut Saya",
        btn_portfolio: "Portofolio Singkat",
        stats: {
          stat1: "Desain Web Selesai Untuk Proyek Mini",
          stat2: "Desain Grafis",
          stat3: "Situs Web Dibuat",
          stat4: "Cangkir Kopi yang Diminum"
        }
      },
      creator: {
        tag: "Kreator Konten YouTube",
        title1: "Sisi Kreatif",
        title2: "YouTube",
        desc: "\"Selain programmer, Sadit Aditya ini punya talenta konten kreator yang membahas media game industri.\"",
        channel1: {
          badge: "Game Mobile & Konsol",
          desc: "Membahas tentang Game Mobile, Konsol, dan menyajikan Tutorial serta Tips Game yang menarik dan informatif."
        },
        channel2: {
          badge: "Media Industri Game",
          desc: "Saluran khusus yang membahas media industri game, perkembangan teknologi game terkini, dan ulasan mendalam."
        },
        subscribers: "Subscriber",
        views: "Tayangan Tertinggi",
        visit: "Kunjungi Saluran",
        featured: "VIDEO UNGGULAN"
      },
      contact: {
        title: "Hubungi Saya",
        subtitle: "Mari Bekerja Sama",
        name: "Nama Lengkap",
        email: "Alamat Email",
        message: "Pesan Anda",
        send: "Kirim Pesan"
      }
    },
    projects: {
      tag: "Semua Proyek",
      title1: "Portofolio",
      title2: "Lengkap",
      desc: "Cari dan filter melalui koleksi proyek saya.",
      search: "Cari proyek berdasarkan judul atau deskripsi...",
      reset: "Atur Ulang Filter",
      noProjects: "Proyek tidak ditemukan",
      noProjectsDesc: "Coba sesuaikan kata kunci pencarian atau kategori filter Anda.",
      showing: "Menampilkan {count} dari {total} proyek",
      viewProject: "Lihat Proyek",
      locked: "Terkunci",
      categories: {
        all: "Semua",
        webApp: "Aplikasi Web",
        mobileApp: "Aplikasi Mobile",
        webDesign: "Desain Web",
        ecommerce: "E-Commerce",
        mobileDev: "Pengembangan Mobile",
        cms: "CMS",
        gameDev: "Pengembangan Game"
      },
      p1_title: "Game Dev Pekanbaru",
      p1_desc: "Website komunitas Game Developer di Pekanbaru untuk berbagi informasi dan proyek game.",
      p2_title: "Teknik Informatika | UIN Suska Riau",
      p2_desc: "Website resmi Program Studi Teknik Informatika UIN Sultan Syarif Kasim Riau.",
      p3_title: "Toko Game | HTML CSS Bootstrap",
      p3_desc: "Toko game dengan harga dan produk yang murah, bersaing, dan terbaik untuk para gamer.",
      p4_title: "Sistem Polling (SISPOL)",
      p4_desc: "Sistem polling untuk melakukan penilaian dari berbagai perusahaan yang bekerja sama dengan Dishub Provinsi Riau.",
      p5_title: "Visitlab Univrab",
      p5_desc: "Website laboratorium kunjungan Universitas Abdurrab untuk mengelola jadwal dan informasi kunjungan lab.",
      p6_title: "SILABO Universitas Abdurrab",
      p6_desc: "Sistem informasi SILABO Universitas Abdurrab untuk pengelolaan perkuliahan.",
      p7_title: "Laporan BUMDES",
      p7_desc: "Sistem pelaporan keuangan untuk Badan Usaha Milik Desa (BUMDES) yang membantu mengelola dan memantau laporan keuangan desa.",
      p8_title: "Universitas Abdurrab",
      p8_desc: "Website resmi Universitas Abdurrab yang memuat informasi kampus, fakultas, dan berita terbaru.",
      p9_title: "Teknik Informatika | Univrab",
      p9_desc: "Website resmi Program Studi Teknik Informatika Universitas Abdurrab.",
      p10_title: "Web | Fakultas Teknik",
      p10_desc: "Web CMS Fakultas Teknik Universitas Abdurrab.",
      p11_title: "Univrab Mobile",
      p11_desc: "Aplikasi absensi Universitas Abdurrab berbasis mobile.",
      p12_title: "Kalkulator Sederhana",
      p12_desc: "Kalkulator sederhana menggunakan JavaScript berbasis HTML.",
      p13_title: "Wordpress | Sadit Aditya",
      p13_desc: "Blog yang membahas seputar Sadit Aditya.",
      p14_title: "Cardlatro",
      p14_desc: "Game kartu strategi yang dikembangkan dan dirilis di platform itch.io.",
      p15_title: "Malpractice Crypt",
      p15_desc: "Game eksplorasi crypt yang dikembangkan dan dirilis di platform itch.io.",
      p16_title: "SMAKOM Digisport",
      p16_desc: "Sistem Manajemen Kompetisi Olahraga untuk berbagai kejuaraan seperti PORPROV dan PORKOT.",
      p17_title: "CBT Universitas Abdurrab",
      p17_desc: "Sistem Ujian Berbasis Komputer (Computer Based Test) Universitas Abdurrab.",
      project1_desc: "Sistem polling untuk melakukan penilaian dari berbagai perusahaan yang bekerja sama dengan Dishub Provinsi Riau.",
      project2_desc: "Aplikasi absensi Universitas Abdurrab berbasis mobile.",
      project3_desc: "Web CMS Fakultas Teknik Universitas Abdurrab.",
      project4_desc: "Game kartu strategi yang dikembangkan dan dirilis di platform itch.io.",
      project5_desc: "Game eksplorasi crypt yang dikembangkan dan dirilis di platform itch.io.",
      project6_desc: "Sistem Manajemen Kompetisi Olahraga untuk berbagai kejuaraan seperti PORPROV dan PORKOT.",
      project7_desc: "Sistem Ujian Berbasis Komputer (Computer Based Test) Universitas Abdurrab."
    },
    footer: {
      privacy: "Kebijakan Privasi",
      terms: "Syarat Layanan",
      contact: "Kontak",
      rights: "Semua Hak Dilindungi."
    },
    chatbot: {
      greeting: "Hai! Apa kabar hari ini? Saya asisten AI untuk portofolio Sadit Aditya. Saya di sini untuk membantu Anda mempelajari tentang keahlian, proyek, dan pengalamannya. Apa yang ingin Anda ketahui?",
      placeholder: "Ketik pesan...",
      typing: "Sedang mengetik...",
      title: "Asisten AI",
      subtitle: "Tanya saya tentang portofolio Sadit!",
      quickQuestions: "Pertanyaan cepat:"
    }
  },
  en: {
    nav: {
      home: "Home",
      projects: "Projects",
      about: "About",
      contact: "Contact",
      hire: "Hire Me"
    },
    home: {
      hero: {
        explore: "Explore My Work",
        contact: "Get In Touch"
      },
      portfolio: {
        tag: "Portfolio",
        title1: "Latest",
        title2: "Projects",
        more: "View More Projects"
      },
      experience: {
        tag: "Journey",
        title1: "EDUCATION & ",
        title2: "EXPERIENCE",
        eduPath: "EDUCATION PATH",
        expPath: "CAREER PATH",
        academic: "Academic Career",
        professional: "Professional Experience",
        role1_desc: "As Mobile Flutter Developer Programmer",
        role2_desc: "As IT support and Implementor Application/System Website Monitor Sports",
        role3_desc: "Internship as a Publication Service and Programmer",
        role4_desc: "As a Content Creator on youtube Channel Sadit Aditya"
      },
      education: {
        edu1_degree: "Graduation (Learning and Management Science)",
        edu2_degree: "Frontend Web Development (FGA)",
        edu2_desc: "Learning React JS Web Development.",
        edu3_degree: "Senior High School",
        edu3_desc: "Science Major"
      },
      services: {
        title: "What I Do",
        desc: "At present time I'm working on a multi-role, as a Web Developer I design and create various websites. And as UI/UX Designer I create many designs for Web Applications and Mobile applications.",
        service1_title: "Working Hard",
        service1_desc: "Always believe in hard-work with Allah May Great my profession",
        service2_title: "UI/UX Design",
        service2_desc: "Designing modern and user-friendly interfaces",
        service3_title: "Web Development",
        service3_desc: "Building responsive and high-performance websites",
        service4_title: "SEO Optimization",
        service4_desc: "Improving your website visibility on search engines"
      },
      about: {
        greeting: "Hello! My Name is Surya Aditya",
        aka: "also known as Sadit Aditya",
        desc1: "I am a ",
        desc1_1: "Frontend Developer",
        desc1_2: " & ",
        desc1_3: "Web Designer",
        desc1_4: " from Pekanbaru, Riau, Indonesia. I enjoy building everything from small business websites to rich, interactive web applications.",
        desc2: "If you are a business seeking a web presence or an employer looking to hire, you can get in touch with me ",
        desc2_link: "here.",
        desc3: "I design and build digital products with simple, beautiful code. I specialize in custom web theme development and truly love what I do.",
        btn_cv: "See My CV",
        btn_hire: "Hire Me",
        btn_portfolio: "Short Portfolio",
        stats: {
          stat1: "Web Design Completed For Mini Project",
          stat2: "Graphic Design",
          stat3: "Website Created",
          stat4: "Cups of Coffee Taken"
        }
      },
      creator: {
        tag: "YouTube Content Creator",
        title1: "Creative Side",
        title2: "YouTube",
        desc: "\"Besides being a programmer, Sadit Aditya also has talent as a content creator discussing the game industry media.\"",
        channel1: {
          badge: "Mobile & Console Games",
          desc: "Discussing Mobile Games, Consoles, and presenting interesting and informative Game Tutorials and Tips."
        },
        channel2: {
          badge: "Game Industry Media",
          desc: "A special channel that discusses game industry media, latest game technology developments, and in-depth reviews."
        },
        subscribers: "Subscribers",
        views: "Highest Views",
        visit: "Visit Channel",
        featured: "FEATURED VIDEO"
      },
      contact: {
        title: "Contact Me",
        subtitle: "Let's Work Together",
        name: "Full Name",
        email: "Email Address",
        message: "Your Message",
        send: "Send Message"
      }
    },
    projects: {
      tag: "All Projects",
      title1: "Complete",
      title2: "Portfolio",
      desc: "Search and filter through my project collection.",
      search: "Search projects by title or description...",
      reset: "Reset Filters",
      noProjects: "No projects found",
      noProjectsDesc: "Try adjusting your search term or filter category.",
      showing: "Showing {count} of {total} projects",
      viewProject: "View Project",
      locked: "Locked",
      categories: {
        all: "All",
        webApp: "Web App",
        mobileApp: "Mobile App",
        webDesign: "Web Design",
        ecommerce: "E-Commerce",
        mobileDev: "Mobile Dev",
        cms: "CMS",
        gameDev: "Game Development"
      },
      p1_title: "Game Dev Pekanbaru",
      p1_desc: "Game Developer community website in Pekanbaru for sharing information and game projects.",
      p2_title: "Informatics Engineering | UIN Suska Riau",
      p2_desc: "Official website for the Informatics Engineering Study Program, UIN Sultan Syarif Kasim Riau.",
      p3_title: "Game Store | HTML CSS Bootstrap",
      p3_desc: "Game store with cheap, competitive, and best products for gamers.",
      p4_title: "Polling System (SISPOL)",
      p4_desc: "Polling system to conduct assessments of various companies collaborating with the Riau Province Transportation Agency.",
      p5_title: "Visitlab Univrab",
      p5_desc: "Laboratory visit website for Universitas Abdurrab to manage schedules and lab visit information.",
      p6_title: "SILABO Universitas Abdurrab",
      p6_desc: "SILABO information system for Universitas Abdurrab to manage lectures.",
      p7_title: "BUMDES Report",
      p7_desc: "Financial reporting system for Village-Owned Enterprises (BUMDES) to help manage and monitor village financial reports.",
      p8_title: "Universitas Abdurrab",
      p8_desc: "Official website of Universitas Abdurrab containing campus information, faculties, and latest news.",
      p9_title: "Informatics Engineering | Univrab",
      p9_desc: "Official website for the Informatics Engineering Study Program, Universitas Abdurrab.",
      p10_title: "Web | Faculty of Engineering",
      p10_desc: "Web CMS for the Faculty of Engineering, Universitas Abdurrab.",
      p11_title: "Univrab Mobile",
      p11_desc: "Mobile-based attendance application for Universitas Abdurrab.",
      p12_title: "Simple Calculator",
      p12_desc: "Simple calculator using JavaScript based on HTML.",
      p13_title: "Wordpress | Sadit Aditya",
      p13_desc: "Blog discussing topics around Sadit Aditya.",
      p14_title: "Cardlatro",
      p14_desc: "A strategy card game developed and released on the itch.io platform.",
      p15_title: "Malpractice Crypt",
      p15_desc: "A crypt exploration game developed and released on the itch.io platform.",
      p16_title: "SMAKOM Digisport",
      p16_desc: "Sports Competition Management System for various championships such as PORPROV and PORKOT.",
      p17_title: "CBT Universitas Abdurrab",
      p17_desc: "Computer Based Test (CBT) System for Universitas Abdurrab.",
      project1_desc: "Polling system to conduct assessments of various companies collaborating with the Riau Province Transportation Agency.",
      project2_desc: "Mobile-based attendance application for Universitas Abdurrab.",
      project3_desc: "Web CMS for the Faculty of Engineering, Universitas Abdurrab.",
      project4_desc: "A strategy card game developed and released on the itch.io platform.",
      project5_desc: "A crypt exploration game developed and released on the itch.io platform.",
      project6_desc: "Sports Competition Management System for various championships such as PORPROV and PORKOT.",
      project7_desc: "Computer Based Test (CBT) System for Universitas Abdurrab."
    },
    footer: {
      privacy: "Privacy Policy",
      terms: "Terms of Service",
      contact: "Contact",
      rights: "All Rights Reserved."
    },
    chatbot: {
      greeting: "Hi! How are you today? I'm your AI assistant for Sadit Aditya's portfolio. I'm here to help you learn about his skills, projects, and experience. What would you like to know?",
      placeholder: "Type a message...",
      typing: "is typing...",
      title: "AI Assistant",
      subtitle: "Ask me about Sadit's portfolio!",
      quickQuestions: "Quick questions:"
    }
  }
};
